module.exports = __webpack_public_path__ + "static/media/B11.3a82dd0c.jpg";